<template>
  <div class="page-head">
    <a href="javascript:;" class="head-logo">
      <img class="logo-100" src="../assets/logo-s.png" alt="" @click="gohome">
    </a>
    <div class="head-user">
      <div class="user-info">
        <span class="head-btn-a" @click="goOther">{{path.indexOf('adjust_home') ? '配单' : '流程'}}</span>
      </div>
    </div>
    <div class="head-user">
      <div class="user-info qh-btn">
        <span class="head-btn-a">{{getLabel(oilArea)}}</span>
        <div class="choose-ps">
          <a href="javascript:;" v-for="item in pszxDatas" @click="oilArea = item.key">{{item.label}}</a>
        </div>
      </div>
    </div>
    <user-info></user-info>
    <div style="display: none">
      {{path}}
    </div>
  </div>
</template>

<script>
import UserInfo from '@/components_bit/UserInfo'

export default {
  components: {
    UserInfo
  },
  props: ['noLogin'],
  data () {
    return {
    }
  },
  computed: {
    path: {
      get () {
        return this.$store.state.route.path
      }
    },
    pszxDatas: {
      get () {
        let showData = []
        this.$store.getters.canChoosePSZXs.forEach((item) => {
          if (item.key !== this.oilArea) {
            showData.push(item)
          }
        })
        return showData
      }
    },
    oilArea: {
      get () {
        return this.$store.getters.oilArea
      },
      set (value) {
        this.$store.dispatch('setOilArea', value)
      }
    }
  },
  methods: {
    goOther () {
      if (this.path.indexOf('adjust_home') > -1) {
        window.open('/#/single_home/single')
      } else {
        window.open('/#/adjust_home')
      }
      window.close()
    },
    getLabel (key) {
      let label = ''
      this.$store.getters.canChoosePSZXs.forEach((item) => {
        if (key === item['key']) {
          label = item.label
        }
      })
      return label
    },
    gohome () {
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
@left-right-width: 13em;
.qh-btn {
  position: relative;
  .choose-ps {
    position: absolute;
    top: 1.2rem;
    right: 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #012e53;
    a {
      transition: 0.3s;
      font-size: 0.8rem;
      line-height: 1.2rem;
      letter-spacing: 3px;
      height: 2rem;
      padding: 0 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-bottom: 0.31em solid #012e53;
    }
    a:hover {
      background-color: #081633;
      border-bottom: 0.31em solid #00ccff;
    }
  }
}
.head-btn-a {
  background-color: #012e53;
  font-size: 0.8rem;
  letter-spacing: 3px;
  line-height: 1.2rem;
  border-radius: 0.2rem;
  padding: 0 1rem;  
}
.qh-btn:hover {
  .choose-ps {
    display: flex;
  }
}
.page-head {
  height: 6.13em;
  background-color: @bak-color-1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.head-logo {
  width: @left-right-width;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 0 0.5em 1.5em;
}
.logo-100 {
  height: 5.6em;
}
.fg-line {
  width: 2px;
  margin:-0.31em 1.625em 1.13em;
  background-color: #fff;
}
.fg-line-2 {
  width: 2px;
  margin:0.625em 0.44em;
  background-color: #fff;
}
.menu-1 {
  transition: 0.3s;
  display: flex;
  flex-direction:row;
  margin: 0 0.625em;
  color: #fff;
  line-height: 1;
  padding-bottom: 1.13em;
  .iconfont {
    font-size: 1.56em;
  }
  span {
    font-size: 1.5em;
    margin-left: 0.625em;
  }
}
.menu-1-active {
  color: @line-color;
}
.head-user {
  display: flex;
  flex-direction:column-reverse;
  width: @left-right-width;
}
.user-info {
  margin:0 1.88em 0.94em 0;
  color: #fff;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  a {
    color: #fff;
    margin-top: 0.44em;
  }
  i {
    font-size: 2.06em;
  }
}
</style>



// WEBPACK FOOTER //
// PageHeadAdjust.vue?b55294a4